import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { DropdownItemComponent } from './dropdown-item.component';
import { DropdownGroupComponent } from './dropdown-group.component';
import { LayoutModule } from '@angular/cdk/layout';
import { DropdownMenuComponent } from './dropdown-menu.component';
import { DropdownTriggerDirective } from './dropdown-trigger.directive';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ButtonModule } from '../button/button.module';
import { UtilsModule } from '../utils/utils.module';
import { LocalizationModule } from '../localization/localization.module';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SvgIconModule,
    ButtonModule,
    UtilsModule,
    LocalizationModule,
  ],
  declarations: [
    DropdownComponent,
    DropdownMenuComponent,
    DropdownGroupComponent,
    DropdownItemComponent,
    DropdownTriggerDirective,
  ],
  exports: [
    DropdownComponent,
    DropdownMenuComponent,
    DropdownGroupComponent,
    DropdownItemComponent,
    DropdownTriggerDirective,
  ]
})
export class DropdownModule {}
